// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@tps/App/SharedStyles/CartLineSharedStyles";
import { rfqQuoteDetailsSalesRepProductListStyles } from "@tps/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList";
import { hideElement, mergeWithCss, modalButtonsActionStyles, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsSalesRepProductListStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

rfqQuoteDetailsSalesRepProductListStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

rfqQuoteDetailsSalesRepProductListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

rfqQuoteDetailsSalesRepProductListStyles.quotedPricingText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

rfqQuoteDetailsSalesRepProductListStyles.quotedPricingStyles = {
    row: {
        mergeCss: true,
        evenRowCss: css`
            background: transparent;
        `,
        css: css`
            border: none;
        `,
    },
    quantityCell: {
        css: css`
            border: none;
            height: 18px;
            vertical-align: top;
            padding: 0 8px 0 0;
            display: flex;
            align-items: baseline;
        `,
    },
    priceCell: {
        css: css`
            border: none;
            height: 18px;
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
    priceWithoutVatCell: {
        css: css`
            border: none;
            height: 30px;
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.uomHeadingAndText = {
    heading: {
        weight: "bold",
        size: 12,
        css: css`
            ${hideElement}
        `,
    },
    text: {
        css: css`
            padding-left: 6px;
            white-space: nowrap;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.quotedPricingContainer = {
    css: css`
        display: flex;
        align-items: flex-start;
        padding-top: 3px;
        > div {
            display: inline-block;
            width: auto;
        }
        > div:first-child {
            display: inline-block;
            width: auto;
            max-width: 140px;
        }

        ${xScreen("lte", "md")} {
            > div:first-child {
                display: inline-block;
                width: auto;
                max-width: 100%;
            }
        }
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.buttonContainer = {
    css: css`
        display: flex;
        justify-content: center;
        button {
            min-height: 32px;
        }
        ${xScreen("lte", "md")} {
            justify-content: flex-end;
        }
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.cartLineContainerStyles = {
    container: {
        css: css`
            grid-template-columns: 99px 15px 2.5fr 1.8fr 1fr 115px 0;
            padding-right: 0;
            padding-left: 0;
            gap: 0;
            ${xScreen("lte", "md")} {
                padding: 12px;
            }
        `,
    },
    description: {
        css: css`
            padding-left: 10px;
        `,
    },
    price: {
        css: css`
            margin-right: 10px;
            ${xScreen("lte", "md")} {
                grid-column: 1 / 4;
                grid-row: 3 / 4;
            }
            ${xScreen("lte", "xs")} {
                grid-column: 1 / 6;
                padding-bottom: 16px;
            }
        `,
    },
    qty: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 4 / 5;
                grid-row: 3 / 4;
                margin-right: 20px;
            }
            ${xScreen("lte", "xs")} {
                grid-column: 1 / 3;
                grid-row: 4 / 5;
                padding-bottom: 5px;
            }
        `,
    },
    total: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 5 / 7;
                grid-row: 3 / 4;
            }
            ${xScreen("lte", "xs")} {
                grid-column: 3 / 7;
                grid-row: 4 / 5;
            }
        `,
    },
    actions: {
        css: css`
            padding-left: 10px;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.linesHeader = {
    wrapper: {
        css: css`
            grid-template-columns: 99px 15px 2.5fr 1.8fr 1fr 115px 0;
            padding-right: 0;
            padding-left: 0;
            gap: 0;
        `,
    },
    itemDescription: {
        css: css`
            padding-left: 12px;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.quoteLineButton = {};

rfqQuoteDetailsSalesRepProductListStyles.buttonsWrapper = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            width: 100%;
            padding: 0;
            &::before {
                width: calc(100% - 20px);
            }
        `,
    }),
};
